import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects super-admin-configured Header/Body/Footer code into every page.
// Scripts are re-created as live nodes so third-party widgets (e.g. Userback) execute.
function injectInto(target, html, slot, position) {
  if (!html || !html.trim()) return;
  if (document.querySelector(`[data-mc-code="${slot}"]`)) return;
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  const marker = document.createComment(`mc-code:${slot}`);
  marker.__mc = slot;
  const nodes = Array.from(wrapper.childNodes);
  const live = nodes.map((node) => {
    if (node.tagName === "SCRIPT") {
      const s = document.createElement("script");
      for (const attr of node.attributes) s.setAttribute(attr.name, attr.value);
      s.text = node.textContent;
      return s;
    }
    return node;
  });
  live.forEach((n) => { if (n.setAttribute) n.setAttribute("data-mc-code", slot); });
  if (position === "prepend" && target.firstChild) {
    live.slice().reverse().forEach((n) => target.insertBefore(n, target.firstChild));
  } else {
    live.forEach((n) => target.appendChild(n));
  }
}

export default function CustomCodeInjector() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("nocustomcode") === "1") { try { localStorage.setItem("mc_nocustomcode", "1"); } catch {} return; }
    if (params.get("nocustomcode") === "0") { try { localStorage.removeItem("mc_nocustomcode"); } catch {} }
    try { if (localStorage.getItem("mc_nocustomcode") === "1") return; } catch {}
    if (window.__mcCodeInjected) return;
    window.__mcCodeInjected = true;
    api.get("/settings/public").then(({ data }) => {
      injectInto(document.head, data.custom_code_head, "head", "append");
      injectInto(document.body, data.custom_code_body, "body", "prepend");
      injectInto(document.body, data.custom_code_footer, "footer", "append");
    }).catch(() => { window.__mcCodeInjected = false; });
  }, []);
  return null;
}
